import { render } from "./SettingsChangePassword.vue?vue&type=template&id=1a732940&scoped=true"
import script from "./SettingsChangePassword.vue?vue&type=script&lang=js"
export * from "./SettingsChangePassword.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a732940"

export default script